.head { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 12px; }
.title { font-size: 14px; font-weight: 600; color: var(--text-title); }
.hint { font-size: 11px; color: var(--text-muted); margin-left: 8px; font-weight: 400; }
.right { display: flex; align-items: center; gap: 12px; }
.count { font-size: 12px; color: var(--text-value); background: #eef1f5; padding: 6px 12px; border-radius: 6px; }
.compare {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 8px 16px; border-radius: 8px; background: #2f6feb; color: #fff;
  font-size: 13px; font-weight: 600;
}
.compare:disabled { background: #a9c0f0; cursor: not-allowed; }

.scroll { overflow: auto; border: 1px solid var(--border-cell); border-radius: 8px; }
.table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 12px; }
.table th {
  position: sticky; top: 0; z-index: 1; background: var(--bg-table-header);
  border-bottom: 1px solid var(--border-cell); border-right: 1px solid var(--border-cell);
  padding: 12px 10px; font-weight: 600; color: var(--text-header); text-align: right; white-space: nowrap;
}
.table td {
  border-bottom: 1px solid var(--border-cell); border-right: 1px solid var(--border-cell);
  padding: 10px; color: var(--text-value); text-align: right; white-space: nowrap;
}
.table th.l, .table td.l { text-align: left; }
.table th.c, .table td.c { text-align: center; }
.row.mine td { background: #f5f8ff; }
.row.on td { background: var(--bg-row-selected); }

.name { display: flex; align-items: center; gap: 10px; min-width: 240px; }
.thumb { width: 34px; height: 34px; border-radius: 6px; background: #f2f3f5; flex-shrink: 0; }
.nameCol { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.nameText { font-weight: 500; color: var(--text-title); overflow: hidden; text-overflow: ellipsis; }
.pills { display: flex; gap: 6px; }
.pill { background: var(--bg-pill); border-radius: 4px; padding: 1px 6px; font-size: 10px; color: var(--text-pill); }
.you { font-size: 10px; color: #2f6feb; font-weight: 600; }
.na { color: #b6bac1; font-size: 11px; }
.state { padding: 48px 0; text-align: center; font-size: 13px; color: var(--text-muted); }
.note { margin-top: 10px; font-size: 11px; color: var(--text-muted); }
